<template>
    <div class="radio-selectors">
        <div v-if="config.label">
            <p>{{ config.label }}</p>
        </div>
        <div class="selectors">
            <div :class="styleClass">
                <label v-for="key in optionKeys" :key="key" class="option mb-md-0" @change="updateModel(key)">
                    <input class="selector" :type="style" :value="key" :checked="isChecked[key]">
                    {{ options[key] }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'RadioSelectors',
        props: {
            id: {
                type: String,
                default: 'group',
            },
            config: {
                type: Object,
                default() {
                    return {
                        options: {},
                    };
                },
            },
            options: {
                type: Object,
                default() {
                    return this.config.options;
                },
            },
            value: {
                type: [Array, Number, String],
                default() {
                    return [];
                },
            },
        },
        computed: {
            optionKeys() {
                return Object.keys(this.options);
            },
            style() {
                return this.config.style || 'radio';
            },
            styleClass() {
                return `fieldset ${this.config.styleClass || ''}`;
            },
            isChecked() {
                const list = {};
                this.optionKeys.forEach((key) => {
                    if (!Array.isArray(this.value)) {
                        // eslint-disable-next-line eqeqeq
                        list[key] = this.value == key;
                    } else {
                        list[key] = this.value.indexOf(key) > -1;
                    }
                });
                return list;
            },
        },
        methods: {
            updateModel(key) {
                if (this.style === 'radio') {
                    this.$emit('input', [key]);
                    return;
                }
                const model = [];
                this.$el.querySelectorAll('.selector').forEach((element) => {
                    const { value, checked } = element;
                    if (checked) {
                        model.push(value);
                    }
                });
                this.$emit('input', model);
            },
        },
    };

</script>
